import React from "react";
import {Box, BoxProps} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";

export type FlexBoxProps = Omit<BoxProps, "gap"> & {
  alignCenter?: boolean;
  justifyCenter?: boolean;
  justifyBetween?: boolean;
  gap?: number;
  column?: boolean;
  fullWidth?: boolean;
};

const FlexBox: React.FC<FlexBoxProps> = ({
  children,
  alignCenter,
  justifyCenter,
  justifyBetween,
  gap,
  column,
  style,
  fullWidth,
  display,
  ...rest
}) => {
  const {spacing} = useTheme();
  return (
    <Box
      display={display || "flex"}
      alignItems={alignCenter && "center"}
      justifyContent={
        justifyCenter
          ? "center"
          : justifyBetween
          ? "space-between"
          : "flex-start"
      }
      flexDirection={column ? "column" : "row"}
      style={{
        gap: gap && spacing(gap),
        width: fullWidth ? "100%" : undefined,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default FlexBox;
